export enum WaterfallTenderRateQuoteExclusionReason {
  EXCLUDED_BY_ROUTING_GUIDE = 'EXCLUDED_BY_ROUTING_GUIDE',
  UNSUPPORTED_TENDER_METHOD = 'UNSUPPORTED_TENDER_METHOD',
  NOT_A_REAL_RATE = 'NOT_A_REAL_RATE',
  MANUAL_EXCLUSION = 'MANUAL_EXCLUSION',
  DO_NOT_DISPATCH = 'DO_NOT_DISPATCH',
}
